import request from '@/utils/request'

//预约公告
export function getAppointmentNotice(params) {
  return request({
    url: '/api/appointmentNotice',
    method: 'get',
    params
  });
}

//获取可预约日期
export function findAppointmentDate(params) {
  return request({
    url: '/api/findAppointmentDate',
    method: 'get',
    params
  });
}
//获取所选日期的可选时间段
export function findAppointmentTimeQuantum(params) {
  return request({
    url: '/api/findAppointmentTimeQuantum',
    method: 'get',
    params
  });
}
//个人预约
export function makeAppointment(data) {
  return request({
    url: '/api/makeAppointment',
    method: 'POST',
    data
  });
}

//我的预约
export function getMyAppointment(params) {
  return request({
    url: '/api/getMyAppointmentPage',
    method: 'get',
    params
  });
}

//取消预约
export function cancelAppointment(data) {
  return request({
    url: '/api/cancelAppointment',
    method: 'POST',
    // 'Content-Type': 'application/json',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/selfAppoint/index.js